import { useContext, useMemo } from 'react';
import { FIELD_TYPES } from '../../../constants';
import { FormContext } from '../../../contexts/form-context';
import { useFormValues } from '../../../contexts/form-values-context';
import { useSiteLanguage } from '../../../contexts/site-language-context';
import { hasMultilineAddress } from '../../../services/multiline-address';
const JAPAN_COUNTRY_CODE = 'JP';
export function useIsJapanOrder() {
  const siteLanguage = useSiteLanguage();
  const form = useContext(FormContext);
  const formValues = useFormValues();
  return useMemo(() => {
    if (form && hasMultilineAddress(form)) {
      const addressField = [...((form == null ? void 0 : form.fields) || []), ...((form == null ? void 0 : form.deletedFields) || [])].find(f => {
        var _f$view, _f$view2;
        return ((_f$view = f.view) == null ? void 0 : _f$view.fieldType) === FIELD_TYPES.MULTILINE_ADDRESS || ((_f$view2 = f.view) == null ? void 0 : _f$view2.fieldType) === FIELD_TYPES.BOOKINGS_ADDRESS;
      });
      if (addressField != null && addressField.target) {
        const addressValue = formValues[addressField.target];
        return (addressValue == null ? void 0 : addressValue.country) === JAPAN_COUNTRY_CODE;
      }
    }
    return (siteLanguage == null ? void 0 : siteLanguage.toLowerCase().startsWith('ja')) ?? false;
  }, [siteLanguage, form, formValues]);
}
//# sourceMappingURL=use-is-japan-order.js.map